<template>
    <div class="input-wrapper input-radio">
        <input
            type="radio"
            :id="'unit-' + type.name + '-id-' + unit.id"
            :name="type.name"
            :value="unit.id"
            :checked="unit.enabled"
        />
        <label :for="'unit-' + type.name + '-id-' + unit.id" @click="submit">
            <strong>
                {{ unit.name }}
                <small>{{ unit.example }}</small>
            </strong>
            <figure>
                <svg
                    aria-hidden="true"
                    focusable="false"
                    width="28px"
                    data-prefix="fas"
                    data-icon="check"
                    class="svg-inline--fa fa-check fa-w-16"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                >
                    <path
                        fill="#00A671"
                        d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                    ></path>
                </svg>
            </figure>
        </label>
    </div>
</template>
<script>
    export default {
        props: {
            unit: {
                type: Object,
                required: true
            },
            type: {
                type: Object,
                required: true
            }
        },
        methods: {
            submit() {
                axios
                    .put(`/api/units/${this.type.name}`, {
                        unit_id: this.unit.id
                    })
                    .then((r) => {
                        this.$emit('unit', this.unit.name)
                        $('#modal-unit-' + this.type.name).modal('hide')
                    })
                    .catch((e) => {
                        console.error(e)
                    })
            }
        }
    }
</script>
